module.exports = __webpack_public_path__ + "static/media/table-secondary.63724105.jpg";